import { z } from "zod";
import { AgencyIdSchema } from "../primitives/ids.js";
/**
 * PF-008 — fail-closed tenant plan / capability policy (skeleton).
 * Does NOT invent a commercial subscription matrix (P1-POL-010).
 * Only explicit internal skeleton keys are allowed.
 *
 * Note: role strings intentionally stay plain strings here to avoid circular
 * imports with agency-auth; API layer validates via AgencyRoleSchema.
 */
export const TenantPlanKeySchema = z.enum(["NONE", "INTERNAL_BASELINE"]);
export const TenantPlanStatusSchema = z.enum(["INACTIVE", "ACTIVE"]);
/** Frozen capability ids for fail-closed gates — not a commercial catalog. */
export const TenantCapabilityIdSchema = z.enum([
    "studio.project.create",
    "notifications.template.write",
    "agency.invite.create",
]);
export const TenantPlanV1Schema = z
    .object({
    schemaVersion: z.literal("tenant-plan.v1.0"),
    agencyId: AgencyIdSchema,
    planKey: TenantPlanKeySchema,
    status: TenantPlanStatusSchema,
    /** Explicit capability allow-list; missing capability → deny. */
    enabledCapabilities: z.array(TenantCapabilityIdSchema),
    updatedAt: z.string().datetime(),
})
    .strict();
export const TenantCapabilityDecisionV1Schema = z
    .object({
    schemaVersion: z.literal("tenant-capability-decision.v1.0"),
    agencyId: AgencyIdSchema,
    capability: TenantCapabilityIdSchema,
    role: z.string().nullable(),
    allowed: z.boolean(),
    reason: z.enum([
        "allowed",
        "plan_missing",
        "plan_inactive",
        "plan_none",
        "capability_not_enabled",
        "role_denied",
        "role_invalid",
    ]),
})
    .strict();
/** Roles permitted per capability when plan enables it (fail-closed). */
export const TENANT_CAPABILITY_ROLE_POLICY = {
    "studio.project.create": ["OWNER", "ADMIN", "OPERATOR", "DESIGNER", "ACCOUNT_MANAGER"],
    "notifications.template.write": ["OWNER", "ADMIN", "OPERATOR"],
    "agency.invite.create": ["OWNER", "ADMIN"],
};
//# sourceMappingURL=tenant-plan.js.map